import React, { Fragment } from 'react'

function CompPrices({titleBanner, price, ofer1, ofer2, ofer3, ofer4, ofer5, ofer6, ofer7, onClick}) {
  return (
    <Fragment>
      <div className='col-lg-4' onClick={onClick}>
                    <div className='card-prices-row'>
                    <div className='banner-card-price'><h3 className='text-banner-card-price'> {titleBanner} </h3></div>
                    <div className='inside-card-price'>
                        <h4 className='price-general'>{price} / MES</h4>
                        <h2 className='text-des-price'>Incluye lo siguiente:</h2>
                        <li>{ofer1}</li>
                        <li>{ofer2}</li>
                        <li>{ofer3}</li>
                        <li>{ofer4}</li>
                        <li>{ofer5}</li>
                        <li>{ofer6}</li>
                        <li>{ofer7}</li>
                        <li>Y mucho más ...</li>
                        <button className='btn-card-price'>Quiero estos beneficios</button>
                    </div>
                    </div>
                </div>
    </Fragment>
  )
}

export default CompPrices
